export const demoConstructionCategories = [
    {
        id: 1,
        name: 'Окна и двери',
        image: './demo/UI/door.png',
        preview: './demo/UI/door.png',
        parentId: null,
        items: [
            1,
            2,
            3,
        ],
    },
];
export const demoCategories = [
    {
        id: 1,
        name: 'Готовые системы',
        image: './demo/UI/wardrobe.png',
    },
    {
        id: 2,
        name: 'Корзины',
        image: '',
    },
    {
        id: 3,
        name: 'Полки',
        image: '',
    },
    {
        id: 4,
        name: 'Обувницы',
        image: '',
    },
    {
        id: 5,
        name: 'Брючницы',
        image: '',
    },
    {
        id: 6,
        name: 'Штанги',
        image: '',
    },
    {
        id: 7,
        name: 'Перфо-панель',
        image: '',
    },
    {
        id: 8,
        name: 'Аксессуары',
        image: '',
    },
];

export const demoMenuItems = [
    {
        id: 1,
        label: 'Label',
        text: 'Description text',
        price: '200',
        img: '',
    },
    {
        id: 2,
        label: 'Label',
        text: 'Description text',
        price: '1000',
        img: '',
    },
    {
        id: 3,
        label: 'Label',
        text: 'Description text',
        price: '1000',
        img: '',
    },
    {
        id: 4,
        label: 'Label',
        text: 'Description text',
        price: '1000',
        img: '',
    },
    {
        id: 5,
        label: 'Label',
        text: 'Description text',
        price: '1000',
        img: '',
    },
    // {
    //     id: 6,
    //     label: 'Label',
    //     text: 'Description text',
    //     price: '1000',
    //     img: '',
    // },
    // {
    //     id: 7,
    //     label: 'Label',
    //     text: 'Description text',
    //     price: '1000',
    //     img: '',
    // },
    // {
    //     id: 8,
    //     label: 'Label',
    //     text: 'Description text',
    //     price: '1000',
    //     img: '',
    // },
];

export const wallColorCategories = [
    {
        id: 1,
        name: 'Краска',
    },
    {
        id: 2,
        name: 'Обои',
    },
    {
        id: 3,
        name: 'Кирпич',
    },
];

export const floorColorCategories = [
    {
        id: 1,
        name: 'Линолеум',
    },
    {
        id: 2,
        name: 'Паркет',
    },
    {
        id: 3,
        name: 'Ковролин',
    },
];

export const wallColorOptions = [
    {
        id: 1,
        name: 'Название',
        img: '',
    },
    {
        id: 2,
        name: 'Название',
        img: '',
    },
    {
        id: 3,
        name: 'Название',
        img: '',
    },
    {
        id: 4,
        name: 'Название',
        img: '',
    },
    {
        id: 5,
        name: 'Название',
        img: '',
    },
    {
        id: 6,
        name: 'Название',
        img: '',
    },
    {
        id: 7,
        name: 'Название',
        img: '',
    },
    {
        id: 8,
        name: 'Название',
        img: '',
    },
];

export const floorColorOptions = [
    {
        id: 1,
        name: 'Название',
        img: '',
    },
    {
        id: 2,
        name: 'Название',
        img: '',
    },
    {
        id: 3,
        name: 'Название',
        img: '',
    },
    {
        id: 4,
        name: 'Название',
        img: '',
    },
    {
        id: 5,
        name: 'Название',
        img: '',
    },
    {
        id: 6,
        name: 'Название',
        img: '',
    },
    {
        id: 7,
        name: 'Название',
        img: '',
    },
    {
        id: 8,
        name: 'Название',
        img: '',
    },
    {
        id: 9,
        name: 'Название',
        img: '',
    },
    {
        id: 10,
        name: 'Название',
        img: '',
    },
];

export const itemColorOptions = [
    {
        id: 1,
        name: 'Белый',
        img: '#ffffff',
        isOutline: true,
    },
    {
        id: 2,
        name: 'Графит',
        img: '#5e5e5e',
        isOutline: false,
    },
];
